import Image from "next/image";
import { NextSeo } from "next-seo";
import { useState } from "react";
import { useRouter } from "next/router";
import Footer from "../../components/Footer";
import { useStoryblok } from "../../lib/storyblok";
import Header from "../../components/Header";
import { StoryProvider, getStaticProps } from "../[...slug]";

export default function TrackOrder({ story: storyProp, ...props }) {
  const story = useStoryblok(storyProp, true);
  const router = useRouter();

  const [orderNumber, setOrderNumber] = useState("");

  const appendOrderNumberToUrl = (orderNumber) => {
    router.push(`track-order/${orderNumber}`);
  };

  return (
    <StoryProvider {...props} story={story}>
      <Header />
      <NextSeo title={`Track Order - Monokel`} />
      <div className="Grid TrackOrder">
        <div className="Grid-block Grid-block--large">
          <div className="TrackOrder-wrapper">
            <div className="TrackOrder-heading">Track your order</div>
            <form
              className="TrackOrder-form"
              onSubmit={(e) => {
                e.preventDefault();
                appendOrderNumberToUrl(orderNumber);
                return false;
              }}
            >
              <input
                name="number"
                className="TrackOrder-input"
                placeholder="Tracking number"
                type="text"
                value={orderNumber}
                onChange={(e) => {
                  setOrderNumber(e.target.value);
                }}
              />
              <button className="TrackOrder-sendButton" type="submit">
                Track
              </button>
            </form>
          </div>
        </div>
        <div className="Grid-block Grid-block--large">
          <Image
            src="/img/error.jpeg"
            alt="Track  Order - Monokel"
            layout="fill"
          />
        </div>
      </div>
      <Footer />
      <div></div>
    </StoryProvider>
  );
}

export { getStaticProps };
